import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { CreditCard } from 'lucide-react'
import { healthCardService, HealthCardData } from '@/services/health_card_service'
import { toast } from 'sonner'

interface HealthCardReaderProps {
  onSuccess: (data: HealthCardData) => void
  onFailed: (error: string) => void
  className?: string
  disabled?: boolean
}

export function HealthCardReader({
  onSuccess,
  onFailed,
  className = '',
  disabled = false,
}: HealthCardReaderProps) {
  const [loading, setLoading] = useState(false)

  const handleReadCard = async () => {
    setLoading(true)
    try {
      const result = await healthCardService.readCard()
      if (result.success && result.data) {
        onSuccess(result.data)
        toast.success('已成功讀取健保卡資料')
      } else {
        const errorMessage = result.error || '讀取健保卡失敗'
        onFailed(errorMessage)
        toast.error(errorMessage)
      }
    } catch (err) {
      const error = err instanceof Error ? err.message : '讀取健保卡時發生未知錯誤'
      onFailed(error)
      toast.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      onClick={handleReadCard}
      disabled={disabled || loading}
      className={className}
      variant="default"
    >
      {loading ? '讀取中...' : '讀取健保卡'} <CreditCard className="ml-2 h-4 w-4" />
    </Button>
  )
}
